import { list } from '@/api'
import {
	LIST_GET_STATUS,
	LIST_GET_ERROR,

	LISTS_GET_META,
	LIST_GET,
	LISTS_CLEAR
} from '@/store/list/types'


const getListsMeta = async (ctx) => {
	ctx.commit(LIST_GET_STATUS, true)

	try {
		const { data } = await list.getListsMeta()

		ctx.commit(LISTS_GET_META, data)
		ctx.commit(LIST_GET_STATUS, false)
	} catch (e) {
		ctx.commit(LIST_GET_ERROR, e)
		ctx.commit(LIST_GET_STATUS, false)

		console.error(e)
	}
}

const getList = async (ctx, {name, query}) => {
	ctx.commit(LIST_GET_STATUS, true)

	try {
		const { data, headers } = await list.getList(name, query)
		const pageCount = headers['x-pagination-page-count']
		const perPage = headers['x-pagination-per-page']
		const totalCount = headers['x-pagination-total-count']
		const currentPage = headers['x-pagination-current-page']

		const response = {
			data,
			name,
			pageCount,
			perPage,
			totalCount,
			currentPage
		}

		ctx.commit(LIST_GET, response)
		ctx.commit(LIST_GET_STATUS, false)
	} catch (e) {
		ctx.commit(LIST_GET_ERROR, e)
		ctx.commit(LIST_GET_STATUS, false)

		console.error(e)
	}
}

const clearLists = async (ctx) => {
	try {
		ctx.commit(LISTS_CLEAR)
	} catch (e) {
		ctx.commit(LIST_GET_ERROR, e)
		ctx.commit(LIST_GET_STATUS, false)

		console.error(e)
	}
}

export default {
	getListsMeta,
	getList,
	clearLists
}


